import React, {
  Children,
  useMemo,
  isValidElement,
  cloneElement,
  type CSSProperties,
  type FC,
  type PropsWithChildren,
  type ReactNode,
  useState,
} from 'react'
import clsx from 'clsx'
import type {TableType} from '../types'
import type {CellProps} from '../Cell'
import styles from './Row.scss'

export type RowProps = {
  gap?: number
  panel?: ReactNode
  className?: string
  type?: TableType
  isHighlighted?: boolean
  isDivider?: boolean
  withAccardion?: boolean
  accardionTextButton?: string
  isDefaultAccardenClosed?: boolean
} & PropsWithChildren

export const Row: FC<RowProps> = (props) => {
  const {
    children,
    panel,
    className,
    gap,
    type = 'admin',
    isHighlighted,
    isDivider,
    withAccardion,
    accardionTextButton = '',
    isDefaultAccardenClosed = false,
  } = props

  const [opened, setOpened] = useState(!isDefaultAccardenClosed)
  const childrens = useMemo(() => Children.map(children, (child) => {
    if (!isValidElement<CellProps>(child)) return child;

    return cloneElement(child, {
      ...child.props,
      type,
      isHighlighted,
    });
  }), [children]);

  const style: CSSProperties = {}
  if (gap !== undefined) {
    style['gap'] = gap
  }

  return (
    <>
      <div className={clsx(
          styles.row,
          styles[`row__${type}`],
          {[styles[`row__${type}--highlighted`]]: isHighlighted},
          {[styles.rowClosed]: !opened},
          className,
        )}
        style={style}
      >
        {panel && <div className={styles.buttonsPanel}>{panel}</div>}
        {withAccardion && (
          <div className={styles.accardion} onClick={() => setOpened((item) => !item)}>
            {accardionTextButton}
            <div className={clsx(styles.icon, opened && styles.icon_opened)}></div>
          </div>
        )}
        {opened && childrens}
      </div>
      {isDivider && <div className={clsx(styles.divider, styles[`divider__${type}`])} />}
    </>
  )
}
